// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var DOM__Search$SmartcutsMacros = require("../devProtocol/DOM__Search.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");
var DOM__Element$SmartcutsMacros = require("../DOM__Element.bs.js");
var Selection__InputCursor$SmartcutsMacros = require("../Selection/Selection__InputCursor.bs.js");
var SelectionSemantics__Shared$SmartcutsMacros = require("./SelectionSemantics__Shared.bs.js");

function t_encode(v) {
  if (typeof v === "number") {
    if (v === /* CursorAtStartOfInput */0) {
      return ["CursorAtStartOfInput"];
    } else {
      return ["CursorAtEndOfInput"];
    }
  }
  switch (v.TAG | 0) {
    case /* CursorAfterNthWord */0 :
        return [
                "CursorAfterNthWord",
                Decco.intToJson(v._0),
                Decco.intToJson(v._1)
              ];
    case /* CursorBeforeNthWord */1 :
        return [
                "CursorBeforeNthWord",
                Decco.intToJson(v._0)
              ];
    case /* CursorInsideNthWordAndOffset */2 :
        return [
                "CursorInsideNthWordAndOffset",
                Decco.intToJson(v._0),
                Decco.intToJson(v._1)
              ];
    case /* CursorInsideNthWord */3 :
        return [
                "CursorInsideNthWord",
                Decco.intToJson(v._0)
              ];
    
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CursorAfterNthWord" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* CursorAfterNthWord */0,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "CursorAtEndOfInput" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CursorAtEndOfInput */1
                  };
          }
      case "CursorAtStartOfInput" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CursorAtStartOfInput */0
                  };
          }
      case "CursorBeforeNthWord" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CursorBeforeNthWord */1,
                      _0: v0._0
                    }
                  };
          }
          var e$2 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "CursorInsideNthWord" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CursorInsideNthWord */3,
                      _0: v0$1._0
                    }
                  };
          }
          var e$3 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "CursorInsideNthWordAndOffset" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* CursorInsideNthWordAndOffset */2,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$4 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function moveCursorToPosition(htmlInputElement, cursorPosition) {
  htmlInputElement.setSelectionRange(cursorPosition, cursorPosition);
  
}

function moveCursorInsideInput(element, semantic) {
  var value = element.value;
  if (typeof semantic === "number") {
    if (semantic === /* CursorAtStartOfInput */0) {
      moveCursorToPosition(element, 0);
      return Promise.resolve({
                  TAG: /* Ok */0,
                  _0: undefined
                });
    }
    var cursorPosition = value.length;
    moveCursorToPosition(element, cursorPosition);
    return Promise.resolve({
                TAG: /* Ok */0,
                _0: undefined
              });
  } else {
    switch (semantic.TAG | 0) {
      case /* CursorAfterNthWord */0 :
          var nth = semantic._0;
          var wordsWithOffsets = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
          var match = Belt_Array.get(wordsWithOffsets, nth);
          if (match === undefined) {
            return Promise.resolve({
                        TAG: /* Error */1,
                        _0: {
                          TAG: /* CouldNotFindNthWord */0,
                          _0: nth
                        }
                      });
          }
          var word = match[1];
          var wordOffset = match[0];
          var cursorPosition$1 = (wordOffset + word.length | 0) + semantic._1 | 0;
          if (cursorPosition$1 > value.length) {
            return Promise.resolve({
                        TAG: /* Error */1,
                        _0: {
                          TAG: /* CouldNotFindOffsetInsideNthWord */1,
                          _0: nth,
                          _1: word,
                          _2: wordOffset
                        }
                      });
          } else {
            moveCursorToPosition(element, cursorPosition$1);
            return Promise.resolve({
                        TAG: /* Ok */0,
                        _0: undefined
                      });
          }
      case /* CursorBeforeNthWord */1 :
          var nth$1 = semantic._0;
          var wordsWithOffsets$1 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
          var match$1 = Belt_Array.get(wordsWithOffsets$1, nth$1);
          if (match$1 !== undefined) {
            moveCursorToPosition(element, match$1[0]);
            return Promise.resolve({
                        TAG: /* Ok */0,
                        _0: undefined
                      });
          } else {
            return Promise.resolve({
                        TAG: /* Error */1,
                        _0: {
                          TAG: /* CouldNotFindNthWord */0,
                          _0: nth$1
                        }
                      });
          }
      case /* CursorInsideNthWordAndOffset */2 :
          var offsetInsideWord = semantic._1;
          var nth$2 = semantic._0;
          var wordsWithOffsets$2 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
          var match$2 = Belt_Array.get(wordsWithOffsets$2, nth$2);
          if (match$2 === undefined) {
            return Promise.resolve({
                        TAG: /* Error */1,
                        _0: {
                          TAG: /* CouldNotFindNthWord */0,
                          _0: nth$2
                        }
                      });
          }
          var word$1 = match$2[1];
          if (offsetInsideWord > word$1.length) {
            return Promise.resolve({
                        TAG: /* Error */1,
                        _0: {
                          TAG: /* CouldNotFindOffsetInsideNthWord */1,
                          _0: nth$2,
                          _1: word$1,
                          _2: offsetInsideWord
                        }
                      });
          }
          var cursorPosition$2 = match$2[0] + offsetInsideWord | 0;
          moveCursorToPosition(element, cursorPosition$2);
          return Promise.resolve({
                      TAG: /* Ok */0,
                      _0: undefined
                    });
      case /* CursorInsideNthWord */3 :
          var nth$3 = semantic._0;
          var wordsWithOffsets$3 = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
          var match$3 = Belt_Array.get(wordsWithOffsets$3, nth$3);
          if (match$3 === undefined) {
            return Promise.resolve({
                        TAG: /* Error */1,
                        _0: {
                          TAG: /* CouldNotFindNthWord */0,
                          _0: nth$3
                        }
                      });
          }
          var offsetInsideWord$1 = (match$3[1].length >> 1);
          var cursorPosition$3 = match$3[0] + offsetInsideWord$1 | 0;
          moveCursorToPosition(element, cursorPosition$3);
          return Promise.resolve({
                      TAG: /* Ok */0,
                      _0: undefined
                    });
      
    }
  }
}

function moveCursorInsideInputLocatedAtSelector(selector, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
  return DOM__Search$SmartcutsMacros.waitForElementInForegroundViaSearch(undefined, undefined, undefined, false, undefined, undefined, undefined, selector).then(function (result_element) {
              if (result_element.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result_element._0
                          });
              }
              var element = result_element._0;
              return DOM__Element$SmartcutsMacros.waitForAnyPossibleOverlayToDisappear(element, undefined, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, undefined).then(function (result) {
                          if (result.TAG === /* Ok */0) {
                            return moveCursorInsideInput(element, semantic).then(function (result) {
                                        if (result.TAG === /* Ok */0) {
                                          return Promise.resolve({
                                                      TAG: /* Ok */0,
                                                      _0: undefined
                                                    });
                                        } else {
                                          return Promise.resolve({
                                                      TAG: /* Error */1,
                                                      _0: {
                                                        TAG: /* InputCursorSemanticError */2,
                                                        _0: result._0
                                                      }
                                                    });
                                        }
                                      });
                          } else {
                            return Promise.resolve({
                                        TAG: /* Error */1,
                                        _0: result._0
                                      });
                          }
                        });
            });
}

function toHumanReadable(semantic) {
  if (typeof semantic === "number") {
    if (semantic === /* CursorAtStartOfInput */0) {
      return "To the beginning of the field";
    } else {
      return "To the end of the field";
    }
  }
  switch (semantic.TAG | 0) {
    case /* CursorAfterNthWord */0 :
        var n = semantic._0 + 1 | 0;
        var nth = StringUtils$SmartcutsMacros.withOrd(n);
        return "" + semantic._1 + " characters after the " + nth + " word";
    case /* CursorBeforeNthWord */1 :
        var n$1 = semantic._0 + 1 | 0;
        var nth$1 = StringUtils$SmartcutsMacros.withOrd(n$1);
        return "Before the " + nth$1 + " word";
    case /* CursorInsideNthWordAndOffset */2 :
        var n$2 = semantic._0 + 1 | 0;
        var nth$2 = StringUtils$SmartcutsMacros.withOrd(n$2);
        var nthInsideWord = StringUtils$SmartcutsMacros.withOrd(semantic._1);
        return "Inside the " + nth$2 + " word, after the " + nthInsideWord + " character";
    case /* CursorInsideNthWord */3 :
        var n$3 = semantic._0 + 1 | 0;
        var nth$3 = StringUtils$SmartcutsMacros.withOrd(n$3);
        return "Anywhere inside the " + nth$3 + " word";
    
  }
}

var Semantic = {
  t_encode: t_encode,
  t_decode: t_decode,
  moveCursorToPosition: moveCursorToPosition,
  moveCursorInsideInput: moveCursorInsideInput,
  moveCursorInsideInputLocatedAtSelector: moveCursorInsideInputLocatedAtSelector,
  toHumanReadable: toHumanReadable
};

function t_encode$1(v) {
  return Decco.arrayToJson(t_encode, v);
}

function t_decode$1(v) {
  return Decco.arrayFromJson(t_decode, v);
}

function stringify(semantics) {
  return "[" + ($$Array.map(toHumanReadable, semantics).join(", ") + "]");
}

function ofInputCursor(inputCursor) {
  var value = inputCursor.value;
  var cursorPosition = inputCursor.cursorPosition;
  if (Selection__InputCursor$SmartcutsMacros.Generic.isCursorAtStartOfInput(inputCursor)) {
    return [/* CursorAtStartOfInput */0];
  }
  if (Selection__InputCursor$SmartcutsMacros.Generic.isCursorAtEndOfInput(inputCursor)) {
    return [/* CursorAtEndOfInput */1];
  }
  var wordsWithPositions = Curry._1(SelectionSemantics__Shared$SmartcutsMacros.$$Text.ParseWords.fromText, value);
  var arg = Util$SmartcutsMacros.shortcutWithIndex2(wordsWithPositions, (function (param, index) {
          var wordStartOffset = param[0];
          var wordEndOffset = wordStartOffset + param[1].length | 0;
          if (wordEndOffset < cursorPosition) {
            return ;
          }
          if (wordEndOffset === cursorPosition) {
            return [{
                      TAG: /* CursorAfterNthWord */0,
                      _0: index,
                      _1: 0
                    }];
          }
          if (wordStartOffset === cursorPosition) {
            return [{
                      TAG: /* CursorBeforeNthWord */1,
                      _0: index
                    }];
          }
          if (wordStartOffset <= cursorPosition) {
            return [
                    {
                      TAG: /* CursorInsideNthWord */3,
                      _0: index
                    },
                    {
                      TAG: /* CursorInsideNthWordAndOffset */2,
                      _0: index,
                      _1: cursorPosition - wordStartOffset | 0
                    }
                  ];
          }
          var match = Caml_array.get(wordsWithPositions, index - 1 | 0);
          var offsetAfterLastWord = cursorPosition - (match[0] + match[1].length | 0) | 0;
          return [{
                    TAG: /* CursorAfterNthWord */0,
                    _0: index - 1 | 0,
                    _1: offsetAfterLastWord
                  }];
        }));
  var param = "Expected cursorPosition, " + (String(cursorPosition) + (", to fall within bounds of value " + value));
  return OptionUtils$SmartcutsMacros.getExn(param, arg);
}

exports.Semantic = Semantic;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.stringify = stringify;
exports.ofInputCursor = ofInputCursor;
/* Util-SmartcutsMacros Not a pure module */
